import { render } from "./ClientNotaCredito.vue?vue&type=template&id=64e18b92&scoped=true"
import script from "./ClientNotaCredito.vue?vue&type=script&lang=js"
export * from "./ClientNotaCredito.vue?vue&type=script&lang=js"

import "./ClientNotaCredito.vue?vue&type=style&index=0&id=64e18b92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64e18b92"]])

export default __exports__